export class TaskUser {
    public userID: string;
    public username: string;
    public email: string;
    public activeTasks: number;
    public roles: string[];
}
